import type { StyleProps } from "@ecco/ui/types";

export const styles = {
    footer: {
        bg: "black",
        flexDirection: "column",
        px: ["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"],
        pt: 2,
        minHeight: "332px",
    },
    // Approximates the deferred form's height per breakpoint so the footer does not reflow.
    // Exact values are impossible: the policy text rewraps continuously with viewport width.
    newsletterPlaceholder: {
        width: "100%",
        minHeight: {
            base: "300px",
            sm: "350px",
            md: "334px",
            lg: "324px",
            xl: "314px",
            "3xl": "295px",
        },
    },
} satisfies Record<string, StyleProps>;
